import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@front/m19-services";
import { ModalService, SpinnerComponent } from "@front/m19-ui";
import { TranslocoService } from "@jsverse/transloco";
import { firstValueFrom } from "rxjs";
import { ProductTourWelcomeModalComponent } from "./product-tour-welcome-modal.component";

const PRODUCT_TOUR_TOKEN_TTL_SECONDS = 12 * 3600;

@Component({
  selector: "app-product-tour",
  template: `<ISpinner main withTitle />`,
  imports: [SpinnerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductTourComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);
  private readonly modalService = inject(ModalService);
  private readonly translocoService = inject(TranslocoService);

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get("token");
    if (!token) {
      this.router.navigateByUrl("/login", { replaceUrl: true });
      return;
    }
    this.authService.setAccessToken(token, PRODUCT_TOUR_TOKEN_TTL_SECONDS, false);
    this.authService
      .reloadUser()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () =>
          this.router
            .navigateByUrl("/", { replaceUrl: true })
            // the product tour is a fresh page load coming from autopilot, translations may not be loaded yet
            .then(() => firstValueFrom(this.translocoService.selectTranslate("product-tour.welcome_title")))
            .then((title) => this.modalService.openModal(ProductTourWelcomeModalComponent, { modalTitle: title })),
        error: () => this.authService.logout(true),
      });
  }
}
